// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0AS85","footerContent":"Footer_footerContent__qLNgf","footer-logo":"Footer_footer-logo__TsG5Y"};